
import { Box, useTheme } from '@mui/material'
import React, { useEffect, useState, useRef, useCallback } from 'react'
import StudentMeetingCard from './StudentMeetingCard'

const StudentMeeting = ({ attendees, tutorStream, meetingStarted, handleStreamStudentAudio, handleStreamStudentCam }) => {
    const theme = useTheme();
    const containerRef = useRef()
    const [cardDimensions, setCardDimensions] = useState()

    const updateCardsSize = useCallback(() => {
        try {
            const gap = 8;
            const count = attendees.length;
            const container = containerRef.current;

            if (!container || !count) {
                setCardDimensions(undefined);
                return;
            }

            const { width: containerWidth, height: containerHeight } = container.getBoundingClientRect();
            if (containerWidth <= 0 || containerHeight <= 0) {
                return;
            }

            const aspectRatio = 16 / 10;
            let best = { cardWidth: containerWidth, cardHeight: containerWidth / aspectRatio };

            for (let columns = 1; columns <= count; columns++) {
                const rows = Math.ceil(count / columns);
                const width = (containerWidth - gap * (columns - 1)) / columns;
                const height = width / aspectRatio;
                const totalHeight = height * rows + gap * (rows - 1);

                if (totalHeight <= containerHeight) {
                    best = { cardWidth: width, cardHeight: height };
                }
            }

            setCardDimensions({
                cardWidth: Math.max(120, best.cardWidth - 2),
                cardHeight: Math.max(90, best.cardHeight - 2),
            });
        } catch (error) {
            console.log("the error from resizing cards is ", error)
        }
    }, [attendees.length])

    useEffect(() => {
        updateCardsSize();
        const resizeObserver = typeof ResizeObserver !== 'undefined' && containerRef.current
            ? new ResizeObserver(updateCardsSize)
            : null;

        if (resizeObserver && containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }

        window.addEventListener('resize', updateCardsSize);
        return () => {
            resizeObserver?.disconnect();
            window.removeEventListener('resize', updateCardsSize);
        }
    }, [updateCardsSize])

    const sidebarWidth = '300px';

    return (
        <Box ref={containerRef} sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '8px',
            top: '60px',
            left: theme.direction === 'ltr' ? 0 : sidebarWidth,
            right: theme.direction === 'ltr' ? sidebarWidth : 0,
            bottom: 0,
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'center',
            position: 'fixed',
            zIndex: 1200,
            maxWidth: '100vw',
            maxHeight: 'calc(100vh - 60px)',
            overflow: 'auto',
            p: 1,
            visibility: meetingStarted ? 'visible' : 'hidden',
            pointerEvents: meetingStarted ? 'auto' : 'none',
            backgroundColor: theme.palette.background.gray,
            '@media (max-width: 900px)': {
                left: 0,
                right: 0,
            }
        }}>
            {attendees.length && cardDimensions && attendees.map((attendee, index) => (
                <StudentMeetingCard key={index} cardDimensions={cardDimensions} attendee={attendee} toturStream={tutorStream} attendeesCount={attendees.length} handleStreamStudentAudio={(attendee) => handleStreamStudentAudio(attendee)} handleStreamStudentCam={(attendee) => handleStreamStudentCam(attendee)} />
            ))}
        </Box>
    )
}

export default StudentMeeting
